import xappaiCoupons from "generated/coupons-xapp-ai";

export interface Coupon {
    id: string;
    name: string;
    amount_off?: number;
    currency?: string;
    duration: "repeating" | "once" | "forever" | string;
    duration_in_months?: number;
    max_redemptions?: number;
    percent_off?: number;
    redeem_by?: number;
}

export function getCoupon(couponId: string): Coupon {
    return xappaiCoupons.find((coupon) => {
        return coupon.id === couponId;
    });
}
